import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.el.addEventListener('click', () => {
            document.querySelector('.ot-floating-button__open').click()
        });
    }
}
